<div class="toaster_container">
    {{data | translate}}
</div>
